import ContactosService from "common/services/ContactosService"
import { CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE } from "common/utils/constants"
import { useEffect, useState } from "react"

const useCamposPersonalizados = (
  endpointSlice = CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE.contacto
) => {
  const [suggestions, setSuggestions] = useState([])
  const [mapedSuggestions, setMapedSuggestions] = useState([])
  const [foundSuggestions, setFoundSuggestions] = useState([])

  const searchItems = (query: $TSMigrationFixMe) => {
    const _foundSuggestions = mapedSuggestions.filter((label) =>
      // @ts-expect-error TS(2339): Property 'toLowerCase' does not exist on type 'nev...
      label?.toLowerCase()?.includes(query.toLowerCase())
    )

    setFoundSuggestions(_foundSuggestions)
  }

  const fetchSuggestions = () => {
    ContactosService.getCamposPersonalizadosSuggestions(endpointSlice).then(
      ({ data }) => {
        setSuggestions(data.items)
        const itemsKeys = data.items.flatMap(
          ({ clave }: $TSMigrationFixMe) => clave
        )
        setFoundSuggestions(itemsKeys)
        setMapedSuggestions(itemsKeys)
      }
    )
  }

  useEffect(() => {
    fetchSuggestions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    suggestions,
    foundSuggestions,
    mapedSuggestions,
    searchItems,
  }
}

export default useCamposPersonalizados
